/* eslint-disable */
// import libs
import React from 'react';

// custom components
import { EnrollmentIDTFConnectionStatusEnum } from '../../../../constsnts/enrollmentIDTFStatus';

// import css
import connectionStyles from 'styles/connectionStatus.css';
import TableStyles from 'styles/table.css';

// Pending - connection code not redeemed.
// Enrolled - connected (connection code redeemed) but not recorded an ECG (study period not started basically).
// Active - study period started but not completed.
// Completed - study period ended.
// Expired - not connected and the connection code is revoked.


const ConnectionStatus = props => {
  const { status } = props;
  const statusToLowerCase = status.toLowerCase();
  let content;

  switch (statusToLowerCase) {
    case EnrollmentIDTFConnectionStatusEnum.PENDING.toLowerCase():
      content = (
        <p className={connectionStyles.connectionStatusPending}>
          {EnrollmentIDTFConnectionStatusEnum.PENDING}
        </p>
      );
      break;
    case EnrollmentIDTFConnectionStatusEnum.ENROLLED.toLowerCase():
      content = (
        <p className={connectionStyles.connectionStatusPending}>
          {EnrollmentIDTFConnectionStatusEnum.ENROLLED}
        </p>
      );
      break;
    case EnrollmentIDTFConnectionStatusEnum.ACTIVE.toLowerCase():
      content = (
        <p className={connectionStyles.connectionStatusConnected}>
          {EnrollmentIDTFConnectionStatusEnum.ACTIVE}
        </p>
      );
      break;
    case EnrollmentIDTFConnectionStatusEnum.COMPLETE.toLowerCase():
      content = (
        <p className={connectionStyles.connectionStatusNotConnected}>
          {EnrollmentIDTFConnectionStatusEnum.COMPLETED}
        </p>
      );
      break;
    case EnrollmentIDTFConnectionStatusEnum.COMPLETED.toLowerCase():
      content = (
        <p className={connectionStyles.connectionStatusNotConnected}>
          {EnrollmentIDTFConnectionStatusEnum.COMPLETED}
        </p>
      );
      break;
    case EnrollmentIDTFConnectionStatusEnum.EXPIRED.toLowerCase():
      content = (
        <p className={connectionStyles.connectionStatusNotConnected}>
          {EnrollmentIDTFConnectionStatusEnum.EXPIRED}
        </p>
      );
      break;
  }
  return <div className={TableStyles.centeredColumnContent}>{content}</div>;
};

export default ConnectionStatus;



// WEBPACK FOOTER //
// ./src/views/components/Common/Table/CellRendererComponents/ConnectionStatus.jsx